import { HTMLProps, forwardRef } from 'react';

import { tv } from '@eluve/components';

const transcriptTextVariants = tv({
  base: 'whitespace-pre-line align-baseline font-normal !leading-10 text-text-secondary posthog-privacy-text',
  variants: {
    interim: {
      true: 'text-text-disabled',
    },
    widgetTranscript: {
      true: '!leading-6',
    },
  },
});

interface TranscriptTextProps extends HTMLProps<HTMLParagraphElement> {
  interim?: boolean;
  widgetTranscript?: boolean;
}

export const TranscriptText = forwardRef<
  HTMLParagraphElement,
  TranscriptTextProps
>(({ children, interim, widgetTranscript, className, ...props }, ref) => {
  return (
    <p
      ref={ref}
      {...props}
      className={transcriptTextVariants({
        interim,
        widgetTranscript,
        className,
      })}
    >
      {children}
    </p>
  );
});
